export const listMarketplaceAccounts = /* GraphQL */ `
  query ListMarketplaceAccounts(
    $filter: ModelMarketplaceAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMarketplaceAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        type
        region
        status
        is_default
        owner
        createdAt
        ebay_config
        description_variant
        publish_delay_hours
        mercari_shipping_payer
        scheduleTimezone
        sku
        closeSteps
        sessionStatus
        sessionExpiresAt
        sessionVerifiedAt
        blockedSince
        analytics(limit: 1, sortDirection: DESC) {
          items {
            id
            activity_date
            self_shares
            community_shares
            listing_count
            sales_count
            sales_total
            total_followers
            total_following
            task_health
            task_runtime
            task_captcha
            task_errors
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listListings = /* GraphQL */ `
  query ListListings(
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listListings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        marketplaceID
        status
        url
        owner
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
    }
  }
`;

export const listListingsByOwnerStatus = /* GraphQL */ `
  query ListListingsByOwnerStatus(
    $owner: String
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listListingsByOwnerStatus(
      owner: $owner
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        marketplace {
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          category
          department
          sub_category
          condition
          sale_price
          images
          listingQuality
          aspects
          measurements
        }
      }
      nextToken
      __typename
    }
  }
`;

export const listInventorysWithListings = /* GraphQL */ `
  query ListInventorys(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        brand
        sku
        barcode
        location
        sale_price
        status
        listingQuality
        createdAt
        images
        imageMetadata

        listings {
          items {
            id
            status
            url
            marketplaceID
            date_listed
            publish_after
            marketplace {
              type
              username
            }
          }
        }
      }
      nextToken
      __typename
    }
  }
`;

export const exportInventorys = /* GraphQL */ `
  query ListInventorys(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        title
        brand
        sku
        location
        category
        condition
        department
        description
        details
        flaws
        sub_category
        aspects
        measurements
        sale_price
        retail_price
        cost_of_goods
        colors
        images
        imageMetadata
        stock
        searchField
        status
        listingQuality
        createdAt
        updatedAt
        listings {
          nextToken
          __typename
        }
        __typename
      }
      nextToken
    }
  }
`;

export const lookupByOwnerAndStatus = /* GraphQL */ `
  query LookupByOwnerAndStatus(
    $owner: String
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lookupByOwnerAndStatus(
      owner: $owner
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        brand
        sku
        barcode
        location
        sale_price
        status
        listingQuality
        createdAt
        images
        imageMetadata

        listings {
          items {
            id
            status
            url
            marketplaceID
            date_listed
            publish_after
            marketplace {
              type
              username
            }
          }
        }
      }
      nextToken
      __typename
    }
  }
`;

export const lookupByOwnerAndSKU = /* GraphQL */ `
  query LookupByOwnerAndSKU(
    $owner: String
    $sku: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lookupByOwnerAndSKU(
      owner: $owner
      sku: $sku
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        brand
        sku
        location
        sale_price
        status
        listingQuality
        createdAt
        images
        imageMetadata

        listings {
          items {
            id
            status
            url
            marketplaceID
            date_listed
            publish_after
            marketplace {
              type
              username
            }
          }
        }
      }
      nextToken
    }
  }
`;


export const tasksByMarketplace = /* GraphQL */ `
  query TasksByMarketplace(
    $marketplaceID: ID
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tasksByMarketplace(
      marketplaceID: $marketplaceID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        marketplaceID
        type
        count
        brand
        status
        schedule
        gmtSchedule
        summary
        owner
        taskOptions
        nextRun
        createdAt
        updatedAt
        marketplace {
          scheduleTimezone
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listingsByListDate = /* GraphQL */ `
  query ListingsByListDate(
    $marketplaceID: ID
    $date_listed: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listingsByListDate(
      marketplaceID: $marketplaceID
      date_listed: $date_listed
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
      __typename
    }
  }
`;

// OPT-59: status + marketplace as two KEY conditions (schema.graphql
// @key createdByMarketplaceID: hash status, sort marketplaceID). The
// generated createdByMarketplaceID in queries.js returns bare rows; the
// Listings page needs the same joined fields as listingsByListDate above.
export const createdByMarketplaceID = /* GraphQL */ `
  query CreatedByMarketplaceID(
    $status: String
    $marketplaceID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    createdByMarketplaceID(
      status: $status
      marketplaceID: $marketplaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
      __typename
    }
  }
`;

export const listingsByOwnerDate = /* GraphQL */ `
  query ListingsByOwnerDate(
    $owner: String
    $date_listed: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listingsByOwnerDate(
      owner: $owner
      date_listed: $date_listed
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          id
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
      __typename
    }
  }
`;

export const listingsByOwnerStatusDate = /* GraphQL */ `
  query ListingsByOwnerStatusDate(
    $owner: String
    $statusDate_listed: ModelListingListingsByOwnerStatusDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listingsByOwnerStatusDate(
      owner: $owner
      statusDate_listed: $statusDate_listed
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          id
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
      __typename
    }
  }
`;

export const listingsByOwnerStatusCreated = /* GraphQL */ `
  query ListingsByOwnerStatusCreated(
    $owner: String
    $statusCreatedAt: ModelListingByOwnerStatusCreatedCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listingsByOwnerStatusCreated(
      owner: $owner
      statusCreatedAt: $statusCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        url
        marketplaceID
        date_listed
        publish_after
        notes
        createdAt
        updatedAt
        marketplace {
          type
          username
        }
        inventory {
          id
          sku
          location
          title
          brand
          sale_price
          images
          listingQuality
        }
      }
      nextToken
      __typename
    }
  }
`;

export const listInventorysSimple = /* GraphQL */ `
  query ListInventorysSimple(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        brand
        sku
        location
        category
        sale_price
        status
        listingQuality
        createdAt
        images
        imageMetadata
        lastVerifiedAt
        lastVerifiedBy
      }
      nextToken
      __typename
    }
  }
`;

// Slim list query for the "Found" tab — returns only items that have a
// lastVerifiedAt set, so we don't drag the entire (potentially large)
// catalog over the wire just to render the audit log.
export const listVerifiedInventoryForChecklist = /* GraphQL */ `
  query ListVerifiedInventoryForChecklist(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        brand
        sku
        location
        status
        images
        imageMetadata
        lastVerifiedAt
        lastVerifiedBy
      }
      nextToken
      __typename
    }
  }
`;

// Slim SKU lookup using the lookupByOwnerAndSKU @key (DynamoDB query, not a
// scan). Returns just the fields the audit checklist needs, including the
// new audit timestamps so we can render verified-state badges immediately.
export const lookupInventoryBySKUForChecklist = /* GraphQL */ `
  query LookupInventoryBySKUForChecklist(
    $owner: String
    $sku: ModelStringKeyConditionInput
    $limit: Int
  ) {
    lookupByOwnerAndSKU(owner: $owner, sku: $sku, limit: $limit) {
      items {
        id
        title
        brand
        sku
        location
        status
        images
        imageMetadata
        lastVerifiedAt
        lastVerifiedBy
      }
    }
  }
`;

// ============================================================================
// Notification Queries, Mutations & Subscriptions
// ============================================================================

export const notificationsByOwnerCreatedAt = /* GraphQL */ `
  query NotificationsByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        type
        priority
        title
        message
        isRead
        metadata
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const notificationsByOwnerReadStatus = /* GraphQL */ `
  query NotificationsByOwnerReadStatus(
    $owner: String
    $isRead: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwnerReadStatus(
      owner: $owner
      isRead: $isRead
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      id
      isRead
      updatedAt
    }
  }
`;

export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification($owner: String) {
    onCreateNotification(owner: $owner) {
      id
      owner
      type
      priority
      title
      message
      isRead
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const getInventoryWithListings = /* GraphQL */ `
  query GetInventoryWithListings($id: ID!) {
    getInventory(id: $id) {
      id
      owner
      importReview
      title
      brand
      sku
      location
      tagColor
      tagColorSource
      category
      condition
      department
      description
      short_description
      barcode
      barcodeSource
      barcodeReview
      details
      flaws
      sub_category
      aspects
      measurements
      sale_price
      retail_price
      cost_of_goods
      colors
      images
      imageMetadata
      stock
      searchField
      status
      listingQuality
      createdAt
      updatedAt
      listings {
        items {
          id
          marketplaceID
          status
          url
          owner
          date_listed
          publish_after
          notes
          createdAt
          updatedAt
          marketplace {
            type
            username
          }
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;

// The barcode fields on their own. The inventory form re-reads these when the
// worker reports in, because a subscription payload carries null for any field
// the triggering mutation did not select, so it cannot tell "cleared" from
// "not selected".
export const getInventoryTagBarcode = /* GraphQL */ `
  query GetInventoryTagBarcode($id: ID!) {
    getInventory(id: $id) {
      id
      barcode
      barcodeSource
      barcodeReview
    }
  }
`;
